<div class="clear"></div>
<section class="banner">
  <div class="container py-4">
    <h1>PPRA STANDARD BIDDING DOCUMENTS (SBDs)</h1>
  </div>
</section>
<div class="clear py-3"></div>
<section class="container">
  <h5 class="pb-3">In pursuance of Section 27 of PPRA Ordinance, 2002 read with Rule 23 of Public Procurement Rules,
    2004, Public Procurement Regulatory Authority has been developed following Standard Bidding Documents (SBDs) .</h5>

  <p><a href="./assets/docs/sbd/730.pdf">National Standard Bidding Document for Procurement of Cloud Services vide
      S.R.O. 730(I)/2024.</a></p>
  <p><a href="./assets/docs/sbd/459.pdf">National Standard Bidding Document for Procurement of Works (Civil Works) vide
      S.R.O. 459(I)/2024.</a></p>
  <p><a href="./assets/docs/sbd/sro700.pdf">PPRA National Standard Bidding Document (Therapeutic Goods -Pharmaceuticals)
      (S.R.O 700(I)/2022).</a></p>
  <p><a href="./assets/docs/sbd/sro370.pdf">PPRA National Standard Bidding Documents (General Goods, Consultancy
      Services and Closed Framework Agreements) (S.R.O 370(I)/2022).</a></p>

  <ul>
    <li>
      <a href="./assets/docs/sbd/sbdcloud.pdf">National Standard Bidding Document for Procurement of Cloud Services
        (S.R.O. 730(I)/2024) –
        [PDF]</a> |
      <a href="./assets/docs/sbd/sbdcloud.doc">[MS Word]</a>
    </li>
    <li>
      <a href="./assets/docs/sbd/sbdcivil.pdf">National Standard Bidding Document for Procurement of Works (Civil Works)
        (S.R.O. 459(I)/2024) –
        [PDF]</a> |
      <a href="./assets/docs/sbd/sbdcivil.doc">[MS Word]</a>
    </li>
    <li>
      <a href="./assets/docs/sbd/sbdtg.pdf">National Standard Bidding Document for Procurement of Therapeutic Goods
        (Pharmaceuticals)
        (S.R.O. 700(I)/2022) –
        [PDF]</a> |
      <a href="./assets/docs/sbd/sbdtg.doc">[MS Word]</a>
    </li>
    <li>
      <a href="./assets/docs/sbd/sbdgoods.pdf">National Standard Bidding Document for Procurement of General Goods
        (S.R.O. 370(I)/2022) –
        [PDF]</a> |
      <a href="./assets/docs/sbd/sbdgoods.doc">[MS Word]</a>
    </li>
    <li>
      <a href="./assets/docs/sbd/sbdrfp.pdf">National Request for Proposal Document for Procurement of Consultancy
        Services –
        [PDF]</a> |
      <a href="./assets/docs/sbd/sbdrfp.doc">[MS Word]</a>
    </li>
    <li>
      <a href="./assets/docs/sbd/sbdcf.pdf">National Standard Procurement Document for Procurement of Goods through
        Closed Framework Agreements –
        [PDF]</a> |
      <a href="./assets/docs/sbd/sbdcf.doc">[MS Word]</a>
    </li>
    <li>
      <a href="./assets/docs/sbd/sbdinfo.pdf">National Standard Bidding Document for Procurement of Information System
        (Supply and Installation) –
        [PDF]</a> |
      <a href="./assets/docs/sbd/sbdinfo.doc">[MS Word]</a>
    </li>
  </ul>

</section>
<div class="clear py-3"></div>